<script setup lang="ts">
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import { getTagPillClass, type TagToggleGroupProps } from './tag-toggle-group';

const props = withDefaults(defineProps<TagToggleGroupProps>(), {
  disabled: false,
});
const emit =
  defineEmits<(event: 'update:modelValue', value: string[]) => void>();

const toggle = (id: string): void => {
  if (props.disabled) return;
  emit(
    'update:modelValue',
    props.modelValue.includes(id)
      ? props.modelValue.filter((selectedId) => selectedId !== id)
      : [...props.modelValue, id],
  );
};
</script>

<template>
  <div role="group" :aria-label="props.label" class="flex flex-wrap gap-2">
    <button
      v-for="tag in props.tags"
      :key="tag.id"
      type="button"
      class="focus-visible:outline-primary-500 inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2"
      :class="getTagPillClass(tag.color, props.modelValue.includes(tag.id))"
      :aria-pressed="props.modelValue.includes(tag.id)"
      :disabled="props.disabled"
      @click="toggle(tag.id)"
    >
      <HugeIcon
        v-if="props.modelValue.includes(tag.id)"
        icon="checkmark"
        :size="14"
      />
      {{ tag.name }}
    </button>
  </div>
</template>
